import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createHead } from '@vueuse/head';
import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import './assets/styles.css';


import { createI18n } from 'vue-i18n'
import en from './locales/en.json'
import cn from './locales/cn.json'
const savedLocale = localStorage.getItem('locale') || 'en'
const i18n = createI18n({
  locale: savedLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    cn
  }
})

const app = createApp(App);
const head = createHead();

app.use(router);
app.use(head);
app.use(i18n)
app.mount('#app');